import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { ControlValueAccessor, FormControl } from '@angular/forms';

let uniqueIndex = 0;

@Component({
  selector: 'irembogov-control-toggle-switch',
  templateUrl: './irembogov-control-toggle-switch.component.html',
  styleUrls: ['./irembogov-control-toggle-switch.component.scss'],
})
export class IrembogovControlToggleSwitchComponent
  implements ControlValueAccessor, OnChanges
{
  @Input() text?: string;
  @Input() startMargin = 'ms-2';
  @Input() disabled = false;
  @Input() labelTextClass = 'my-2';
  @Input() customFormControl = new FormControl();
  @Output() switchChanged: EventEmitter<boolean> = new EventEmitter();

  readonly uniqueComponentIndex = uniqueIndex++;

  // eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars
  private _onChange = (_: unknown) => {};
  // eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars
  private _onTouch = (_: unknown) => {};

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['disabled']?.currentValue) {
      this.disabled = changes['disabled'].currentValue;
    }
  }

  writeValue(value: boolean): void {
    this.customFormControl.setValue(value);
  }
  registerOnChange(fn: () => void): void {
    this._onChange = fn;
  }
  registerOnTouched(fn: () => void): void {
    this._onTouch = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  updateValue(event: boolean) {
    this.writeValue(event);
  }

  onChange($event?: Event | null): void {
    if ($event) {
      const isChecked = ($event.target as HTMLInputElement).checked;
      this._onChange(isChecked);
      this._onTouch(isChecked);
      this.customFormControl.setValue(isChecked);
      this.switchChanged.emit(isChecked);
    }
  }
}
